// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./static/js/" + chunkId + "." + {"61":"d9aa156e","242":"9d3cfee3","607":"0545fe8c","878":"37277841","888":"f0ad7462","947":"b6f085dd"}[chunkId] + ".js";
};